<template>
  <div class="tips-container">
    <div class="tips-image">
      <img src="@/client/assets/images/tips_light_bulb.svg" />
    </div>
    <div class="tips-message">
      <slot />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({})
</script>

<style lang="scss" scoped>
@use '@/client/assets/scss/variables.scss' as *;

.tips-container {
  display: flex;
  align-items: center;
}

.tips-image {
  display: flex;
  align-items: center;
  margin-right: $spacing-unit;
}

.tips-message {
  font-size: $font-small-size;
  color: $sub-text-color;
}
</style>
